import {
  AfterViewChecked,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { Store } from '@ngrx/store';
import { combineLatest, map } from 'rxjs';
import { SubSink } from 'subsink';

import { ProgressStatusType } from '@app/purchase-lists/interfaces/purchase-progress-status-type';
import {
  PurchaseListsActions,
  PurchaseListsSelectors,
} from '@app/purchase-lists/store/purchase-lists.slice';
import { UserService } from '@authentication/services/user.service';
import { AuthenticationSelectors } from '@authentication/store/authentication.slice';
import { MerchantSelectors } from '@merchant/store/merchant.slice';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterViewChecked, OnDestroy {
  @ViewChild('context', { read: ElementRef })
  context!: ElementRef<HTMLElement>;
  margin = 0;
  // private lastScrollTop = 0;

  switcherReady = false;

  switcherOpened$ = this.store.select(
    AuthenticationSelectors.selectSwitcherOpened
  );

  siteSelected$ = this.store.select(MerchantSelectors.selectIsSiteSelected);

  roles: string[] = [];
  isRetailer = false;

  subs = new SubSink();

  screenWidth!: number;
  screenHeight!: number;

  constructor(
    public readonly authenticator: AuthenticatorService,
    public readonly router: Router,
    private userService: UserService,
    private store: Store
  ) {
    this.subs.sink = this.switcherOpened$.subscribe((opened) => {
      this.switcherReady = true;
    });
    this.subs.sink = this.userService.currentUserRoles.subscribe((roles) => {
      if (roles && JSON.stringify(roles) !== JSON.stringify(this.roles)) {
        this.roles = roles;
      }
    });

    this.subs.sink = this.store
      .select(MerchantSelectors.selectBasicData)
      .subscribe((basicData) => {
        if (basicData) {
          this.isRetailer =
            !!basicData.highestMerchantType?.includes('RETAILER');
        }
      });
  }

  get isAdminMode() {
    return (
      this.roles.includes('EASYLOT_ADMIN') ||
      this.roles.includes('IMPERSONATION')
    );
  }
  get isTelesalesMode() {
    return this.roles.includes('TELESALES');
  }

  ngOnInit() {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
  }

  @HostListener('window:resize', ['$event'])
  onResize(_event: any) {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
  }

  ngAfterViewChecked(): void {
    const width = this.context?.nativeElement?.parentElement?.offsetWidth ?? 0;
    if (width === 0) {
      this.margin = 0;
    } else {
      this.margin = width;
    }
  }

  get showMarketButton() {
    if (
      this.authenticator.route === 'authenticated' &&
      !this.roles.includes('EASYLOT_ADMIN') &&
      !this.roles.includes('TELESALES') &&
      !this.roles.includes('IMPERSONATION')
    ) {
      return true;
    }
    return false;
  }

  // @HostListener('window:scroll', ['$event'])
  // onWindowScroll($event: Event) {
  //   const scrollTop = ($event.target as any)!.scrollingElement.scrollTop;
  //   if (scrollTop < this.lastScrollTop) {
  //     this.hidden = false;
  //   } else {
  //     if (scrollTop > 64) {
  //       this.hidden = true;
  //     }
  //   }
  //   this.lastScrollTop = scrollTop;
  // }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
